var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Right(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_3769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.36796 0.256339C9.28755 0.171537 9.19097 0.103702 9.08391 0.0568377C8.97686 0.00997325 8.8615 -0.014972 8.74465 -0.0165247C8.62779 -0.0180773 8.51181 0.00379344 8.40355 0.0477969C8.29529 0.0918003 8.19694 0.157045 8.1143 0.23968C8.03167 0.322315 7.96642 0.420667 7.92242 0.528929C7.87842 0.637192 7.85654 0.753171 7.8581 0.870024C7.85965 0.986877 7.88459 1.10224 7.93146 1.20929C7.97832 1.31635 8.04616 1.41293 8.13096 1.49334L12.763 6.12534L0.874959 6.12534C0.642895 6.12534 0.420334 6.21753 0.25624 6.38162C0.0921459 6.54572 -4.06851e-05 6.76827 -4.06648e-05 7.00034C-4.06445e-05 7.2324 0.0921459 7.45496 0.25624 7.61906C0.420335 7.78315 0.642895 7.87534 0.874959 7.87534L12.763 7.87534L8.13196 12.5063C7.97505 12.6718 7.88895 12.892 7.89198 13.12C7.89501 13.348 7.98693 13.5659 8.14818 13.7271C8.30943 13.8884 8.52726 13.9803 8.75527 13.9833C8.98329 13.9864 9.20349 13.9002 9.36896 13.7433L15.493 7.61834C15.6569 7.45426 15.749 7.2318 15.749 6.99984C15.749 6.76788 15.6569 6.54541 15.493 6.38134L9.36796 0.256339Z",
    fill: "#6F6F6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_3769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.75,
    height: 14,
    fill: "white",
    transform: "translate(15.75 14) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Right);
export default __webpack_public_path__ + "static/media/icons8-right.b7bcbf626927abafa823c897553a3846.svg";
export { ForwardRef as ReactComponent };